import axios from "axios";

const domainsExploreBaseURL = "/api/v1/domains_explore";

const fetchCdes = (id, page = 1, per = 10, search = "") =>
  axios.get(
    `${domainsExploreBaseURL}/cde_definitions/${id}?page=${page}&per_page=${per}&search=${search}`
  );

const createCde = (id, payload) =>
  axios.post(`${domainsExploreBaseURL}/cde_definitions/${id}`, {
    cde_definition: payload,
  });

const associateCdes = (id, payload) =>
  axios.post(`${domainsExploreBaseURL}/cde_definitions/${id}/associate`, {
    cde_definition: payload,
  });

const fetchDataSources = (id, page = 1, per = 10, search = "") =>
  axios.get(
    `/api/v1/domains_explore/${id}/data_sources?page=${page}&per_page=${per}&search=${search}`
  );

const associateDomains = (id, payload) =>
  axios.post(`/api/v1/domains_explore/${id}/data_sources/associate`, {
    data_source: payload,
  });

const fetchBusinessTerms = (id, page = 1, per = 10, search = "") =>
  axios.get(
    `${domainsExploreBaseURL}/${id}/business_terms?page=${page}&per_page=${per}&search=${search}`
  );

const associateBusinessTerms = (id, payload) =>
  axios.post(`${domainsExploreBaseURL}/${id}/business_terms/associate`, {
    business_term: payload,
  });

const createBusinessTerm = (id, payload) =>
  axios.post(`${domainsExploreBaseURL}/${id}/business_terms`, {
    business_term: payload,
  });

const fetchReferenceSources = (id, page = 1, per = 10, search = "") =>
  axios.get(
    `${domainsExploreBaseURL}/${id}/reference_sources?page=${page}&per_page=${per}&search=${search}`
  );

const associateReferenceSources = (id, payload) =>
  axios.post(`${domainsExploreBaseURL}/${id}/reference_sources/associate`, {
    reference_source: payload,
  });

const domainsExploreApi = {
  fetchCdes,
  createCde,
  associateCdes,
  fetchDataSources,
  associateDomains,
  fetchBusinessTerms,
  createBusinessTerm,
  associateBusinessTerms,
  fetchReferenceSources,
  associateReferenceSources,
};

export default domainsExploreApi;
